import ActionType from 'actions/ActionType'

export default (
  state = { value: null, label: '--', key: `noEmailSelectValue` },
  action,
) => {
  switch (action.type) {
    case ActionType.Tasks.SELECT_FROM_EMAIL:
      return action.payload
    case ActionType.Tasks.RECEIVE_TASK:
      if (action?.payload?.send_email?.trigger_data?.from) {
        return {
          value: action.payload.send_email.trigger_data.from,
          label: action.payload.send_email.trigger_data.from,
          key: `${action.payload.send_email.trigger_data.from}SelectValue`,
        }
      }
      return { value: null, label: '--', key: `noEmailSelectValue` }
    default:
      return state
  }
}
